<template>
  <div class="card" @click="moveToDetails">
    <template v-if="settlement">
      <div class="status-glow" :style="{ background: glowGradient }"></div>
      <div class="status-border" :style="{ borderColor: statusMetaData.color }"></div>
    </template>
    <div v-if="settlement" class="status-corner">
      <img class="status-icon-img" :src="statusMetaData.icon" :alt="statusMetaData.label" />
      <div class="status-tooltip">
        <div>
          {{ monthLabel }}:
          <strong :style="{ color: statusMetaData.color }">{{ statusMetaData.label }}</strong>
        </div>
        <div v-if="settlement.lastChangeAt" class="tooltip-change">
          Ost. zmiana: {{ settlement.lastChangeByName }}
          {{ formatDateTime(settlement.lastChangeAt) }}
        </div>
      </div>
    </div>
    <div class="name">{{ employee.firstName }} {{ employee.lastName }}</div>
    <div class="phone">{{ employee.phone }}</div>
    <div class="address">{{ employee.address }}</div>
    <div class="footer">
      <div>
        <img src="../../icons/dod/read_message.svg" alt="" />
        <span class="ml-2">{{ employee.numberOfMessages }}</span>
      </div>

      <div>
        <img src="../../icons/dod/notes.svg" alt="" />
        <span class="ml-2">{{ employee.numberOfTasks }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { statusMeta } from "./settlement/statusMeta";

const MONTHS = ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"];

export default {
  name: "EmployeeCard",
  components: {},
  props: {
    employee: {
      type: Object,
    },
    settlement: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    statusMetaData() {
      return statusMeta(this.settlement ? this.settlement.status : "NIEROZLICZONO");
    },
    monthLabel() {
      if (!this.settlement || !this.settlement.month) return "";
      return `${MONTHS[this.settlement.month - 1]} ${this.settlement.year}`;
    },
    // Miękka poświata narożnika w kolorze statusu (alfa w hex: 66 = ~40%, 1f = ~12%).
    glowGradient() {
      const c = this.statusMetaData.color;
      return `radial-gradient(circle at 100% 0%, ${c}66 0%, ${c}1f 22%, transparent 50%)`;
    },
  },
  methods: {
    moveToDetails() {
      this.$router.push({
        name: "DodEmployeeDetails",
        params: { id: this.employee.id },
      });
    },
    formatDateTime(value) {
      const d = new Date(value);
      const p = (n) => String(n).padStart(2, "0");
      return `${p(d.getHours())}:${p(d.getMinutes())} ${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
    },
  },
};
</script>
<style scoped>
.card {
  width: calc(100% * (1 / 4) - 10px - 1px);
  display: flex;
  padding: 16px;
  border-radius: 8px;
  border: 0.5px solid var(--granatowy-25, rgba(9, 7, 65, 0.25));
  background: var(--white-white, #fff);
  box-shadow: 0px 4px 15px 0px rgba(96, 108, 128, 0.25);
  margin-bottom: 1rem;
  cursor: pointer;
  height: 136px;
  justify-content: center;
  position: relative;
}
.status-glow {
  position: absolute;
  top: 0;
  right: 0;
  width: 120px;
  height: 120px;
  border-top-right-radius: 8px;
  pointer-events: none;
  z-index: 0;
}
.status-border {
  position: absolute;
  top: 0;
  right: 0;
  width: 54px;
  height: 54px;
  border-top: 2px solid;
  border-right: 2px solid;
  border-top-right-radius: 8px;
  pointer-events: none;
  z-index: 1;
}
.status-corner {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.status-icon-img {
  width: 22px;
  height: 22px;
  display: block;
}
.status-tooltip {
  display: none;
  position: absolute;
  top: 26px;
  right: 0;
  background: #fff;
  color: #090741;
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
  font-size: 11px;
  white-space: nowrap;
  z-index: 30;
}
.status-corner:hover .status-tooltip {
  display: block;
}
.tooltip-change {
  color: #666;
  margin-top: 4px;
}
.footer {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.name {
  color: var(--gray-800, #1f2633);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 0.5rem;
}
.phone,
.address {
  color: var(--gray-800, #1f2633);
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 15.6px */
}
.card:hover {
  background: #f1f1f1;
}
</style>
